/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cases_Filter_CreationInputs */

const en_cases_filter_creation = /** @type {(inputs: Cases_Filter_CreationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creation`)
};

const pt_br2_cases_filter_creation = /** @type {(inputs: Cases_Filter_CreationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criação`)
};

/**
* | output |
* | --- |
* | "Creation" |
*
* @param {Cases_Filter_CreationInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const cases_filter_creation = /** @type {((inputs?: Cases_Filter_CreationInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Filter_CreationInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cases_filter_creation(inputs)
	return pt_br2_cases_filter_creation(inputs)
});